import api from "./api/api";
import type { AxiosError } from "axios";

const getErrorResponse = (error: unknown) =>
  (error as AxiosError).response;

const AdLinkChatService = {
  getComments: async (addeskId: number) => {
    try {
      const res = await api.get(`/comentarios/addesk/${addeskId}`);
      return res;
    } catch (error: unknown) {
      return getErrorResponse(error);
    }
  },

  sendComment: async (
    addeskId: number,
    content: string,
    files?: FileList | File[] | Blob | null,
    fileDisplayNames?: string[],
  ) => {
    try {
      const formData = new FormData();
      formData.append("content", content);
      formData.append("addesk_id", String(addeskId));

      if (files) {
        // Se for um Blob (áudio gravado)
        if (files instanceof Blob) {
          formData.append("files", files, "audio.webm");
        }
        // Se for FileList ou File[] (arquivos selecionados)
        else if (files.length > 0) {
          Array.from(files).forEach((file) => {
            formData.append("files", file);
          });
        }
      }

      if (fileDisplayNames?.length) {
        formData.append("fileDisplayNames", JSON.stringify(fileDisplayNames));
      }

      const res = await api.post("/comentarios/addesk", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res;
    } catch (error: unknown) {
      return getErrorResponse(error);
    }
  },

  getReunionComments: async (reunionId: number) => {
    try {
      const res = await api.get(`/comentarios/reunion/${reunionId}`);
      return res;
    } catch (error: unknown) {
      return getErrorResponse(error);
    }
  },

  sendReunionComment: async (
    reunionId: number,
    content: string,
    files?: FileList | File[] | Blob | null,
    fileDisplayNames?: string[],
  ) => {
    try {
      const formData = new FormData();
      formData.append("content", content);
      formData.append("reunion_id", String(reunionId));

      if (files) {
        // Se for um Blob (áudio gravado)
        if (files instanceof Blob) {
          formData.append("files", files, "audio.webm");
        }
        // Se for FileList ou File[] (arquivos selecionados)
        else if (files.length > 0) {
          Array.from(files).forEach((file) => {
            formData.append("files", file);
          });
        }
      }

      if (fileDisplayNames?.length) {
        formData.append("fileDisplayNames", JSON.stringify(fileDisplayNames));
      }

      const res = await api.post("/comentarios/reunion", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res;
    } catch (error: unknown) {
      return getErrorResponse(error);
    }
  },

  getPagamentoComments: async (pagamentoId: number) => {
    try {
      const res = await api.get(`/comentarios/pagamento/${pagamentoId}`);
      return res;
    } catch (error: unknown) {
      return getErrorResponse(error);
    }
  },

  sendPagamentoComment: async (
    pagamentoId: number,
    content: string,
    files?: FileList | File[] | Blob | null,
    fileDisplayNames?: string[],
  ) => {
    try {
      const formData = new FormData();
      formData.append("content", content);
      formData.append("pagamento_id", String(pagamentoId));

      if (files) {
        if (files instanceof Blob) {
          formData.append("files", files, "audio.webm");
        } else if (files.length > 0) {
          Array.from(files).forEach((file) => {
            formData.append("files", file);
          });
        }
      }

      if (fileDisplayNames?.length) {
        formData.append("fileDisplayNames", JSON.stringify(fileDisplayNames));
      }

      const res = await api.post("/comentarios/pagamento", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res;
    } catch (error: unknown) {
      return getErrorResponse(error);
    }
  },

  updateComment: (commentId: number, content: string) =>
    api.put(`/comentarios/chat/${commentId}`, { content }),

  deleteComment: (commentId: number) =>
    api.delete(`/comentarios/chat/${commentId}`),
};

export default AdLinkChatService;
